import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import { Grid } from '@material-ui/core'
import CustomTypography from './CustomTypography'

const useStyles = makeStyles(() => ({
  root: {},
  title: {
    fontWeight: 700,
  },
}))
const DescriptionListIcon = (props) => {
  const {
    title,
    subtitle,
    icon,
    align,
    titleVariant,
    subtitleVariant,
    className,
    titleProps,
    subtitleProps,
    ...rest
  } = props

  const classes = useStyles()

  let gridJustify = 'center'

  if (align === 'left') {
    gridJustify = 'flex-start'
  } else if (align === 'right') {
    gridJustify = 'flex-end'
  }

  return (
    <Grid
      container
      spacing={2}
      {...rest}
      className={clsx('description-list-icon', classes.root, className)}
    >
      <Grid
        item
        container
        justifyContent={gridJustify}
        xs={12}
        className="description-list-icon__icon-wrapper"
      >
        {icon}
      </Grid>
      <Grid item xs={12} className="description-list-icon__title-wrapper">
        <CustomTypography
          variant={titleVariant}
          color="textPrimary"
          align={align}
          className={clsx(classes.title, 'description-list-icon__title')}
          {...titleProps}
        >
          {title}
        </CustomTypography>
      </Grid>
      {subtitle && (
        <Grid item xs={12} className="description-list-icon__subtitle-wrapper">
          <CustomTypography
            variant={subtitleVariant}
            color="textSecondary"
            align={align}
            className="description-list-icon__subtitle"
          >
            {subtitle}
          </CustomTypography>
        </Grid>
      )}
    </Grid>
  )
}

DescriptionListIcon.defaultProps = {
  align: 'center',
  titleVariant: 'h6',
  subtitleVariant: 'body1',
  titleProps: {},
  subtitleProps: {},
}

DescriptionListIcon.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  icon: PropTypes.node.isRequired,
  align: PropTypes.oneOf(['left', 'right', 'center']),
  titleVariant: PropTypes.string,
  subtitleVariant: PropTypes.string,
  titleProps: PropTypes.object,
  subtitleProps: PropTypes.object,
}

export default DescriptionListIcon
